/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import MainScreen from './screen/MainScreen';
import { DataStoreProvider, UserProvider } from './providers';
import Loader from './components/Loader';

const App = () => {
  return (
    <UserProvider>
      <DataStoreProvider enableIssueTypeDetection>
        <div>
          <Loader />
          <MainScreen />
        </div>
      </DataStoreProvider>
    </UserProvider>
  );
};

export default App;
